export default __webpack_public_path__ + "static/discover_1-ce8f65022822cfb7ecf7ac911c5f69a7.jpg";